// extracted by mini-css-extract-plugin
module.exports = {"getBestPrice":"_1VkkO","getBestPriceWrapper":"_1l54j","regNumber":"_1OyzG","eliteGetBestPriceBanner":"oF0d8","elitePageReg":"o90PR"};